var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.60866 16.418C6.29199 15.6846 7.33366 15.743 7.93366 16.543L8.77533 17.668C9.45033 18.5596 10.542 18.5596 11.217 17.668L12.0587 16.543C12.6587 15.743 13.7003 15.6846 14.3837 16.418C15.867 18.0013 17.0753 17.4763 17.0753 15.2596V5.86797C17.0837 2.50964 16.3003 1.66797 13.1503 1.66797H6.85033C3.70033 1.66797 2.91699 2.50964 2.91699 5.86797V15.2513C2.91699 17.4763 4.13366 17.993 5.60866 16.418Z",
    fill: "white",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 5.83203H13.3337",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5 9.16797H12.5",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.188174232ee3fbf540d19a094a7afa04.svg";
export { ForwardRef as ReactComponent };